<template>
	<div class="post-footer">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default{
	name: 'PostFooter'
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/Post/PostFooter.vue